import React from 'react';
import { Card } from '../ui';
import { excerpt, htmlToText } from '../../utils/text';

/**
 * The opening of an entity's wiki page, on its overview.
 *
 * An overview is a summary of a record, so the wiki appears here as the few
 * sentences it opens with and a way through to the rest — not as the whole
 * article with its headings, tables and images pushed into a side column.
 */
export const WikiExcerpt: React.FC<{
  html?: string | null;
  /** Opens the Wiki tab */
  onOpen: () => void;
  /** Shown when there is no page yet */
  empty?: React.ReactNode;
  className?: string;
}> = ({ html, onOpen, empty = 'No wiki content', className = '' }) => {
  const text = htmlToText(html ?? '');
  const short = excerpt(text);

  return (
    <Card padded className={className}>
      {short ? (
        <>
          {/* A wiki can carry a link with nothing to break on; without the
              wrapping here it sets its own width and runs past the card */}
          <p className="min-w-0 text-[13px] leading-relaxed text-neutral-600 [overflow-wrap:anywhere]">
            {short}
          </p>
          <button
            type="button"
            onClick={onOpen}
            className="mt-2 inline-flex h-6 items-center rounded-full text-[12.5px] text-neutral-500 transition-colors hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600/30"
          >
            {text.length > short.length ? 'Read more' : 'Open the wiki'}
          </button>
        </>
      ) : (
        <p className="text-[13px] text-neutral-400">{empty}</p>
      )}
    </Card>
  );
};
